var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getSelectedProduct && _vm.getSelectedProduct.colors.length > 0
    ? _c(
        "div",
        { staticClass: "fade-in-fwd text-center", attrs: { id: "#step-3" } },
        [
          _c("div", { staticClass: "mt-2 mb-2" }, [
            _c(
              "div",
              { staticClass: "d-flex justify-content-end pl-1 pr-2 mb-1" },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn black hover-red transition-color medium text-size-small",
                    attrs: { type: "button" },
                    on: { click: _vm.selectAllColors }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.areAllColorsSelected
                            ? _vm.$resourceString[
                                "myProject.Project.AddItemModal.ProductStep3.UnselectAll.Label"
                              ]
                            : _vm.$resourceString[
                                "myProject.Project.AddItemModal.ProductStep3.SelectAll.Label"
                              ]
                        ) +
                        "\n        "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "swatch-image-section row" },
              _vm._l(_vm.step3, function(color) {
                return _c(
                  "div",
                  {
                    key: color.id,
                    staticClass: "col-3 swatch-image-item px-1"
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn wf-product-room-scene-color-item-button",
                        class: {
                          "wf-product-room-scene-color-item-button-active": _vm.isSelected(
                            color
                          ),
                          "wf-product-room-scene-color-item-button-disabled": !color.colorNumber
                        },
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.updateColor(color)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "w-100 h-100",
                          attrs: {
                            src: color.imagePath
                              ? color.imagePath
                              : color.imageLink,
                            alt: ""
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "wf-product-room-scene-color-item-name"
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(color.colorName) +
                                "\n              "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n              " +
                                _vm._s(color.colorNumber) +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            )
          ])
        ]
      )
    : _c("div", { staticClass: "container mb-5 mt-5" }, [
        _c("p", {}, [
          _vm._v(_vm._s(_vm.$resourceString["common.NoDataAvailable.Msg"]))
        ])
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }